/**
 * Text content for various bits, extracted to
 *  make internationalization easier
 * @rally (POP internationalization) https://rally1.rallydev.com/#/?detail=/userstory/819561116563&fdp=true
 */
export const Text = {
  AS_OF: 'as of',
  EXPENSE_RATIO: 'Expense Ratio',
  CATEGORY: 'Category',
  NAV: 'NAV',
  MARKET_PRICE: 'Market Price',
  WATCHLIST: 'Add to Watchlist',
} as const;

export const Selectors = {
  TICKER: 'ticker',
  AS_OF_DATE: 'as-of-date',
  NAME: 'name',
  BODY: 'body-zone',
  CATEGORY: 'category',
  EXPENSE_RATIO: 'expense-ratio',
  NAV: 'nav',
  MARKET_PRICE: 'market-price',
} as const;

export const Constants = {
  TAG_NAME: 'pop-product-tile-ui-component',
} as const;
